module.exports = "/static/assets/bd5dbefe48e72f4358d96f907b42497d.png";